/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Impressum_TitleInputs */

const en_impressum_title = /** @type {(inputs: Impressum_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impressum`)
};

const de_impressum_title = /** @type {(inputs: Impressum_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impressum`)
};

const fr_impressum_title = /** @type {(inputs: Impressum_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mentions légales`)
};

const es_impressum_title = /** @type {(inputs: Impressum_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aviso legal`)
};

const it_impressum_title = /** @type {(inputs: Impressum_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note legali`)
};

const nl_impressum_title = /** @type {(inputs: Impressum_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colofon`)
};

const pl_impressum_title = /** @type {(inputs: Impressum_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informacje prawne`)
};

const fi_impressum_title = /** @type {(inputs: Impressum_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sivuston tiedot`)
};

const da_impressum_title = /** @type {(inputs: Impressum_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kolofon`)
};

const sv_impressum_title = /** @type {(inputs: Impressum_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om tjänsten`)
};

/**
* | output |
* | --- |
* | "Impressum" |
*
* @param {Impressum_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const impressum_title = /** @type {((inputs?: Impressum_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impressum_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_impressum_title(inputs)
	if (locale === "fr") return fr_impressum_title(inputs)
	if (locale === "es") return es_impressum_title(inputs)
	if (locale === "it") return it_impressum_title(inputs)
	if (locale === "nl") return nl_impressum_title(inputs)
	if (locale === "pl") return pl_impressum_title(inputs)
	if (locale === "fi") return fi_impressum_title(inputs)
	if (locale === "da") return da_impressum_title(inputs)
	if (locale === "sv") return sv_impressum_title(inputs)
	return en_impressum_title(inputs)
});